import { type WorkspaceAgentDisplayTool } from '~/components/v2/components/workspace/workspace-agent-panel/utils/groupWorkspaceAgentMessagesForDisplay';

export const WORKSPACE_AGENT_DEFAULT_ACTIVE_RUN_LABEL = 'Working on it…';
const FINISHING_UP_LABEL = 'Finishing up…';

export const WORKSPACE_AGENT_CANCELLING_RUN_LABEL = 'Stop acknowledged…';
export const WORKSPACE_AGENT_CANCELLING_RUN_LABEL_FULL = 'Cancellation acknowledged. Finishing existing work.';

const isInProgressToolStatus = (status: WorkspaceAgentDisplayTool['status']): boolean =>
  status === 'working' || status === 'awaitingApproval';

export type GetWorkspaceAgentActiveRunLabelParams = {
  tools: WorkspaceAgentDisplayTool[];
};

/** Live status line for an in-flight run group. */
export const getWorkspaceAgentActiveRunLabel = ({ tools }: GetWorkspaceAgentActiveRunLabelParams): string => {
  const inProgressTool = tools.find((tool) => isInProgressToolStatus(tool.status));

  if (inProgressTool) {
    return inProgressTool.label;
  }

  if (tools.length > 0) {
    return FINISHING_UP_LABEL;
  }

  return WORKSPACE_AGENT_DEFAULT_ACTIVE_RUN_LABEL;
};
